// data/treeCatalog.js
export const treeCatalog = [
  // ASH
  {
    category: "Ash",
    primary: "Autumn Purple",
    others: ["Mancana", "Patmore"],
    image: "/images/tree/catalog/ashAutumn.png",
    alt: "Autumn Purple Ash",
  },

  // ASPEN
  {
    category: "Aspen",
    primary: "Dancing Flame",
    others: ["Forest Silver", "Quaking – common", "Swedish"],
    image: "/images/tree/catalog/aspenDance.png",
    alt: "Aspen ‘Dancing Flame’",
  },

  // CHOKECHERRY
  {
    category: "Chokecherry",
    primary: "Canada Red",
    others: ["Common"],
    image: "/images/tree/catalog/chokecherry.png",
    alt: "Chokecherry ‘Canada Red’",
  },

  // COTONEASTER (shrub)
  {
    category: "Cotoneaster",
    primary: "Peking",
    others: [],
    desc: "A hardy shrub with dense branching; great for structure and wildlife value.",
    image: "/images/tree/treeFarm/cotoneasterPeking.png",
    alt: "Peking Cotoneaster (shrub)",
  },

  // CRABAPPLE
  {
    category: "Crabapple",
    primary: "Spring Snow",
    others: [
      "Adams",
      "Indian Magic",
      "Perfect Prince",
      "Perfect Purple",
      "Prairie",
      "Royalty",
      "Starlite",
    ],
    image: "/images/tree/catalog/crabappleSpringSnow.png",
    alt: "Crabapple ‘Spring Snow’",
  },

  // FIR (client list doesn’t specify cultivars—placeholder description)
  {
    category: "Fir",
    primary: "",
    others: [],
    desc: "Cold-hardy firs available seasonally—ask about current stock suited to Sun Valley.",
    image: "/images/tree/catalog/firGeneric.png",
    alt: "Fir",
  },

  // HAWTHORNE
  {
    category: "Hawthorne",
    primary: "Crimson Cloud",
    others: ["Crus-galli", "Russian"],
    image: "/images/tree/catalog/crimsonTree.png",
    alt: "Hawthorne ‘Crimson Cloud’",
  },

  // JUNIPER
  {
    category: "Juniper",
    primary: "Wichita Blue",
    others: [],
    desc: "Striking blue foliage; tough and drought-tolerant—great for screening and structure.",
    image: "/images/tree/treeFarm/JuniperWBlue.png",
    alt: "Juniper ‘Wichita Blue’",
  },

  // LINDEN
  {
    category: "Linden",
    primary: "Greenspire",
    others: ["Redmond"],
    image: "/images/tree/catalog/lindenGreenspire.png",
    alt: "Linden ‘Greenspire’",
  },

  // MAPLE
  {
    category: "Maple",
    primary: "Autumn Blaze",
    others: ["Armstrong", "Ginola"], // kept client spelling
    image: "/images/tree/catalog/autumnBlaze.png",
    alt: "Maple ‘Autumn Blaze’",
  },

  // PINE
  {
    category: "Pine",
    primary: "Bristlecone",
    others: ["Lodgepole", "Tannenbaum"],
    image: "/images/tree/catalog/pineBristlecone.png",
    alt: "Bristlecone Pine",
  },

  // PLUM
  {
    category: "Plum",
    primary: "Newport",
    others: [],
    desc: "Ornamental spring bloom and rich foliage color—compact and highly adaptable.",
    image: "/images/tree/catalog/plumNewport.png",
    alt: "Newport Plum",
  },

  // SPRUCE
  {
    category: "Spruce",
    primary: "Yukon Blue",
    others: ["Bonnie Blue", "Colorado – standard", "Fat Albert"],
    image: "/images/tree/catalog/yukonSpruce.png",
    alt: "Yukon Blue Spruce",
  },

  // WILLOW
  {
    category: "Willow",
    primary: "Flame",
    others: [],
    desc: "Fast-growing with vivid stem color—excellent for winter interest and habitat.",
    image: "/images/tree/treeFarm/willowFlame.png",
    alt: "Flame Willow",
  },
];
